import { render, staticRenderFns } from "./MfaSection.vue?vue&type=template&id=96b3f20a&scoped=true&"
import script from "./MfaSection.vue?vue&type=script&lang=js&"
export * from "./MfaSection.vue?vue&type=script&lang=js&"
import style0 from "./MfaSection.vue?vue&type=style&index=0&id=96b3f20a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b3f20a",
  null
  
)

export default component.exports